export default "__VITE_ASSET__mkZkGUVs__"